import { useGetExperiment } from '../../experiments/hooks'
import { EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER } from '../../experiments/model/EXPERIMENT_NAME'
import { type EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { experimentAccessorNonDefault } from '../../experiments/model/experimentAccessor'

type CartIntermediateExperimentType = {
  currentVariant: EXPERIMENT_VARIATION | null
  isExperimentNonDefault: boolean
}

export const useGetCartIntermediateExperimentData =
  (): CartIntermediateExperimentType => {
    const cartIntermediateExperiment = useGetExperiment(
      EXPERIMENT_NAME_CART_INTERMEDIATE_DRAWER,
    )

    const isExperimentNonDefault = experimentAccessorNonDefault(
      cartIntermediateExperiment,
    )
    const currentVariant = cartIntermediateExperiment.variant ?? null

    return { currentVariant, isExperimentNonDefault }
  }
